import type { LocalizedText } from "../registration/layoutHandles.ts";
import { useLocalizedText } from "./useLocalizedText.ts";

export function NavigationItemLabel(props: LocalizedText) {
    // oxlint-disable-next-line wl/public-text-subtree -- useLocalizedText resolves a registered navigation resource key through the hook's own one-arg t()
    return <span data-public>{useLocalizedText(props)}</span>;
}
